import React from "react";
import ReactDOM from "react-dom";
import unsplash from "../api/unsplash";
import Header from "./Header";
import { CCallout } from '@coreui/react'
import Sidebar from "./Sidebar";
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CFormLabel,CForm,CContainer,CFormInput,CRow,CCol,CInputGroupText,CButton,CTableBody,CTableHeaderCell,CTableDataCell,CInputGroup } from '@coreui/react'
import CIcon from '@coreui/icons-react';
import { cilBell, cilEnvelopeOpen, cilFolder,cilFolderOpen, cilGlobeAlt, cilUser,cilPhone, cilLocationPin,cilHome } from '@coreui/icons';
import '../style/style.scss';
import { Route, useNavigate } from "react-router";
import { useLocation } from "react-router";
import '../style/style.css';





class CopertinaCliente extends React.Component {
    constructor (props)
    {
        super(props);

        this.state = {
            cliente: []
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleClick = async(e,data) => {
        var idChecklist=""
        
        if(this.state.cliente.Checklist == 0 ){
          alert("NESSUNA CHECKLIST PRESENTE PER QUESTO CLIENTE, VERRA' CREATA");
          try{
          const response = await unsplash.post('createCheckList',{auth : "a5d42c3ed7977afa2d8e922569e7940b",id:this.state.cliente.ID},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );
          this.state.cliente["Checklist"] = response.data.message.insertId
          const responseEmergenza = await unsplash.post('adlEmergenza',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );
          const responseStruttura = await unsplash.post('adlStrutture',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );
          const responseFormazione = await unsplash.post('formzFormazione',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  ); 
          const responseAmbienti = await unsplash.post('dtAmbienti',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );
          const responseAttrezzature = await unsplash.post('dtAttrezzature',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );  
          const responseImpianti = await unsplash.post('dtImpianti',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );
          const responseVAlutazione = await unsplash.post('vdrDocValutazione',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );  
          const responseDatiAziendali = await unsplash.post('daDatiAziendali',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  );  
          
          
          unsplash.post('updateClienti',{auth : "a5d42c3ed7977afa2d8e922569e7940b",cliente:this.state.cliente,idChecklist:response.data.message.insertId},
          { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}  )
            .then(res => {
                console.log("ok");
 
              })

              alert("CHECKLIST CREATA CON SUCCESSO");
              this.props.navigate('/checkList',{state:{idChecklist:this.state.cliente.Checklist,cliente:this.state.cliente}})
            }
            catch{
              alert("IMPOSSIBILE CREARE LA CHECKLIST ATTUALMENTE");
            }

            
    
        }else{
          this.props.navigate('/checkList',{state:{idChecklist:this.state.cliente.Checklist,cliente:this.state.cliente}})
        }

  
    
     
      

  }

   handleChange(e){
    let cliente = this.state.cliente;
    let {name: fieldName, value} = e.target;

   
    cliente[fieldName] = value;



  

    this.setState({cliente});

  }
    componentDidMount(props){ //dopo che l'elemento si è caricato
        //console.log(this.props.location.state);
      console.log(this.props.location)
        unsplash.post('clientDetail',{auth : "a5d42c3ed7977afa2d8e922569e7940b",id:this.props.location.state.idC},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  )
        .then(res => {
            console.log(res.data);
            const cliente = res.data.data[0];
            console.log(cliente);
            if (!cliente.Logo){
              cliente.Logo = require("../assets/images/MILLERLogo.jpg").default;
            }else{
              cliente.Logo="data:image/png;base64,"+cliente.Logo;
            }
            this.setState({ cliente });
            document.getElementById("RagioneSociale").Value=cliente.RagioneSociale
            console.log(this.state.cliente);
          })
        }



render(){
    return (<div>
           
        
<img src={this.state.cliente.Logo} className="rounded mx-auto d-block" style={{width:"200px",heigth:"200px",marginBottom:"20px"}} alt="non c'è foto"></img>

{/*<CCallout color="info">*/}
<CContainer>
<CForm>
  <div className="mb-3">
    <center><h2>{this.state.cliente.RagioneSociale}</h2></center>
  <CRow className="align-items-start">
    <CCol md={5}>
    <CFormLabel htmlFor="Progetto">Progetto</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="basic-addon1" className="iconColor"><CIcon icon={cilGlobeAlt} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="RagioneSociale" value={this.state.cliente.Progetto} name="Progetto" placeholder=""/>
    </CInputGroup>
    </CCol>
    <CCol md={3}>
    <CFormLabel htmlFor="UsciteDaContratto">Uscite Da Contratto</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="basic-addon1" className="iconColor"><CIcon icon={cilFolder} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="RagioneSociale" value={this.state.cliente.UsciteAttive} name="Progetto" placeholder=""/>
    </CInputGroup>
    </CCol>
    <CCol md={4}>
    <CFormLabel htmlFor="UsciteDaContratto">Uscite Effettuate {new Date().getFullYear()}</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="basic-addon1" className="iconColor"><CIcon icon={cilFolderOpen} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="RagioneSociale" value={this.state.cliente.UsciteEffettuate} name="Progetto" placeholder=""/>
    </CInputGroup>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="Ateco">Rischio - Ateco</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="Ateco" className={this.state.cliente.Rischio} style={{color:"white"}}>{this.state.cliente.Rischio}</CInputGroupText>
    <CFormInput type="text" id="Rischio" value={this.state.cliente.CodiceATECO} name="Ateco" placeholder=""/>
    </CInputGroup>
    </CCol>
  
    <CCol md={6}>
    <CFormLabel htmlFor="Tecnico">Referente Cliente</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="ReferenteCliente" className="iconColor"><CIcon icon={cilUser} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="ReferenteCliente" value={this.state.cliente.Referente} name="ReferenteCliente" placeholder=""/>
    </CInputGroup>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="Mail">Mail</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="Mail" className="iconColor"><CIcon icon={cilEnvelopeOpen} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="Mail"  name="Mail" value={this.state.cliente.EmailReferente} placeholder=""/>
    </CInputGroup>
    </CCol>
    <CCol md={6}>
    <CFormLabel htmlFor="Telefono">Telefono</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="Telefono" className="iconColor"><CIcon icon={cilPhone} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="Telefono" value={this.state.cliente.TelefonoReferente}  name="Telefono" placeholder=""/>
    </CInputGroup>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="IndirizzoSedeLegale">Indirizzo Sede Legale</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="IndirizzoSedeLegale" className="iconColor"><CIcon icon={cilHome} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="IndirizzoSedeLegale" value={this.state.cliente.SedeIndirizzo} name="IndirizzoSedeLegale" placeholder=""/>
    </CInputGroup>
    </CCol>
    <CCol md={6}>

    <CFormLabel htmlFor="IndirizzoSedeOperativa">Indirizzo Sede Operativa</CFormLabel>
    <CInputGroup className="mb-3">
    <CInputGroupText id="IndirizzoSedeOperativa" className="iconColor"><CIcon icon={cilLocationPin} size="lg" style={{color:"white"}}/></CInputGroupText>
    <CFormInput type="text" id="IndirizzoSedeOperativa" value={this.state.cliente.PostaIndirizzo} name="IndirizzoSedeOperativa" placeholder=""/>
    </CInputGroup>
    </CCol>
    </CRow>
    
    <CRow className="align-items-start" >
    <CButton color="success" style={{marginTop:"40px"}} onClick={((e) => this.handleClick(e))}>Checklist</CButton>
      </CRow>
    {/*TABELLA SOTTO*/ }
    
    {/*TABELLA RIGA UNICA*/ }
    
  </div>
 
</CForm>
</CContainer>

    </div>);
}
}

function WithNavigate(props) {
    const location = useLocation();
    const navigate = useNavigate()
  
    return <CopertinaCliente {...props} location={location} navigate={navigate}/>;
  }
  
  export default WithNavigate
  
  //`data:image/png;base64,${this.state.cliente.Logo}`    